import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faChevronCircleDown
} from '@fortawesome/pro-light-svg-icons'
import {
	faFacebookF,
	faInstagram,
	faTwitter,
	faLinkedinIn
} from '@fortawesome/free-brands-svg-icons'

library.add(
	faChevronCircleDown,
	faFacebookF,
	faInstagram,
	faTwitter,
	faLinkedinIn
)

const Icon = props =>
	<FontAwesomeIcon { ...props } />

Icon.ChevronCircleDown = () => <Icon icon={ faChevronCircleDown } />
Icon.Facebook = () => <Icon icon={ faFacebookF } />
Icon.Instagram = () => <Icon icon={ faInstagram } />
Icon.Twitter = () => <Icon icon={ faTwitter } />
Icon.LinkedIn = () => <Icon icon={ faLinkedinIn } />

export { Icon }
